import type { MaintenanceType } from '@portal/portal-api'
import { css } from '@portal/styled-system/css'

import { getAssetUrl } from '@/shared/lib/cdn'
import { useI18n } from '@/shared/lib/i18n'
import { BackgroundImage } from '@/shared/ui'

import { playUiAssets } from './assets'
import { gameOverlayRecipe } from './recipe'

export type MaintenanceProps = {
    type: MaintenanceType
}

export function Maintenance(props: MaintenanceProps) {
    const { i18n } = useI18n()

    switch (props.type) {
        case 'none':
            return null
        case 'upgrade':
            return <MaintenanceUpgrade text={i18n.TEXT_systemUpdate} />
        case 'technical':
            return <MaintenanceTechnical text={i18n.TEXT_systemMaintenance} />
    }
}

function MaintenanceUpgrade(props: { text: string }) {
    const styles = gameOverlayRecipe({ bubblePosition: 'upgrade' })

    return (
        <BackgroundImage src={playUiAssets.overlayBackground} className={styles.overlay}>
            <img src={getAssetUrl(playUiAssets.parrot)} alt="Update" className={css({ pt: '6' })} draggable="false" />
            <BackgroundImage src={playUiAssets.bubbleBackground} className={styles.bubble}>
                <p className={styles.bubbleText} dangerouslySetInnerHTML={{ __html: props.text }} />
            </BackgroundImage>
        </BackgroundImage>
    )
}

function MaintenanceTechnical(props: { text: string }) {
    const styles = gameOverlayRecipe({ bubblePosition: 'technical' })

    return (
        <BackgroundImage src={playUiAssets.overlayBackground} className={styles.overlay}>
            <img src={getAssetUrl(playUiAssets.chicken)} alt="Maintenance" draggable="false" />
            <BackgroundImage src={playUiAssets.bubbleBackground} className={styles.bubble}>
                <p className={styles.bubbleText} dangerouslySetInnerHTML={{ __html: props.text }} />
            </BackgroundImage>
        </BackgroundImage>
    )
}
